const pcMenus = [
    {
        key: 'MENU.FILE.NEW',
        label: '新建',
        shortcutKey: [
            'Ctrl+N',
            '⌘+N'
        ]
    },
    {
        key: 'MENU.FILE.OPEN',
        label: '打开',
        shortcutKey: [
            'Ctrl+O',
            '⌘+O'
        ]
    },
    {
        key: 'MENU.HELP',
        label: '帮助',
        menus: [
            {
                key: 'MENU.HELP.GUIDE',
                label: '用户指引',
                shortcutKey: ''
            },
            {
                key: 'MENU.HELP.UPDATER.CHECKER',
                label: '检查更新',
                shortcutKey: ''
            },
            {
                key: 'MENU.HELP.FEEDBACK',
                label: '意见反馈',
                shortcutKey: '',
                link: '/list/help/feedback'
            },
            {
                key: 'MENU.HELP.ABOUT',
                label: '关于',
                shortcutKey: '',
                link: '/list/help/about'
            }
        ]
    },
    {
        key: 'MENU.LANGUAGE',
        label: '语言'
    },
    {
        key: 'MENU.EXIT',
        label: '退出'
    }
];

const webMenus = [
    {
        key: 'MENU.FILE.NEW.WEB',
        label: '新建',
        shortcutKey: [
            'Ctrl+N',
            '⌘+N'
        ]
    },
    {
        key: 'MENU.FILE.OPEN.WEB',
        label: '打开',
        link: '/projects?projects'
    },
    {
        key: 'MENU.FILE.SAVE.WEB',
        label: '保存',
        shortcutKey: [
            'Ctrl+S',
            '⌘+S'
        ],
        'showSplit': true
    },
    {
        key: 'MENU.FILE.SAVEAS.WEB',
        label: '另存为',
        shortcutKey: [
            'Ctrl+Shift+S',
            '⌘+⇧+S'
        ]
    },
    {
        key: 'MENU.FILE.IMPORT',
        label: '从计算机导入'
    }, {
        key: 'MENU.FILE.EXPORT',
        label: '保存到计算机'
    },
    {
        key: 'MENU.FILE.PUBLISH.TO',
        label: '分享至'
    },
    {
        key: 'MENU.FILE.DEMOS',
        label: '示例程序',
        link: '/projects?demos'
    },
    {
        key: 'MENU.HELP',
        label: '帮助',
        menus: [
            {
                key: 'MENU.HELP.GUIDE',
                label: '用户指引',
                shortcutKey: ''
            },
            {
                key: 'MENU.HELP.FEEDBACK',
                label: '意见反馈',
                shortcutKey: '',
                link: '/help/feedback'
            },
            {
                key: 'MENU.HELP.ABOUT',
                label: '关于',
                shortcutKey: '',
                link: '/help/about'
            }
        ]
    }
];

export {
    pcMenus as default,
    webMenus
};